import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { ApiService } from 'src/app/api/api.service';
import * as dayjs from 'dayjs';
import * as dayjsLocal from 'dayjs/plugin/localizedFormat';
import { AlertController, ModalController } from '@ionic/angular';
import { AutomaticStepTypes, ClientStepTypes, StepTypes } from '../../components/steps/StepTypes';
import { GlobalService } from 'src/app/api/global.service';
import { TimeAndBillingService } from 'src/app/time-and-billing/time-and-billing.service';
import { StepTypes as stepTypeEnum } from '../../components/steps/StepTypes';

import { CreatePage as SurveyCreatePage } from '../../surveys/create/create.page';
import { SelectPage as SurveySelectPage } from '../../surveys/select/select.page';
import { SelectComponent as SkillsSelectPage } from 'src/app/components/tags/select/select.component';
import { CreatePage } from '../create/create.page';
import { DetailsPage as ProjectDetailsPage } from 'src/app/projects/details/details.page';
import { CreatePage as TimeAndBillingCreatePage } from 'src/app/time-and-billing/create/create.page';
import { TaskStatus } from 'src/app/components/tasks/TaskStatus';


@Component({
  selector: 'app-details',
  templateUrl: './details.page.html',
  styleUrls: ['./details.page.scss'],
})
export class DetailsPage implements OnInit, OnDestroy {
  //Takes in both the task ID and the task itself
  @Input() guid: string;
  @Input() project: any = null;
  task: any = null;
  current_edit_task_copy = '';
  activeIndex = 'Details';
  // Opened from an @mention notification: the comment to scroll to and highlight on the Comments tab
  @Input() focus_comment: any = null;
  refresh = false;
  current_user: any = null;
  task_copy: any = null;
  client_roles: any = [];
  require_roles = false;
  require_specific = false;

  comment: any = {
    reply_to: null,
    reply_to_text: null,
    comment: ''
  }

  inline_assign_member_guid: string = null;
  taskInternalStatuses: any[] = [];
  open_missing_info_count: number = 0;
  total_comment_count: number = 0;
  comment_filter: string = 'This Task';
  all_comments: any[] = [];
  this_task_comments: any[] = [];
  other_task_comments: any[] = [];
  project_comments_list: any[] = [];
  step_comments: any[] = [];
  comments_loading: boolean = false;
  active_reply_guid: string = null;
  reply_comment: any = { reply_to: null, reply_to_text: null, reply_to_name: null, comment: '', update: false };
  time_and_billing: any[] = [];

  constructor(private apiService: ApiService, private modalController: ModalController, public globalService: GlobalService,private alertController: AlertController, private timeAndBillingService: TimeAndBillingService) {

  }

  private time_changes_subscription: Subscription;

  ngOnInit() {
    this.current_user = this.globalService.GetCurrentUser();
    this.GetData();
    // A time entry was created or deleted somewhere (the timer, the project...) - reload the list if it's showing
    this.time_changes_subscription = this.timeAndBillingService.changes$.subscribe(() => {
      if (this.activeIndex == 'Time Entries') this.LoadTimeEntries();
    });
  }

  ngOnDestroy() {
    this.time_changes_subscription?.unsubscribe();
  }

  async GetData() {
    await this.globalService.presentLoading("Loading Task Data", 99999999);
    await this.GetTaskData();
    await this.GetClientRoles();
    await this.GetProject();
    const statusData: any = await this.apiService.get('tags/tasks_internal_status');
    if (statusData.success) this.taskInternalStatuses = statusData.data || [];
    this.globalService.dismissLoading();
    this.GetOpenMissingInfoCount();
    this.GetTotalCommentCount();
    if (this.activeIndex === 'Comments') this.GetTaskComments();
  }

  async TaskInternalStatusChange() {
    this.apiService.put(`tasks/${this.task.guid}`, { internal_status: this.task.internal_status });
  }

  GetInternalStatusByGuid(guid: string) {
    if (!guid || !this.taskInternalStatuses?.length) return null;
    return this.taskInternalStatuses.find(s => s.guid === guid) || null;
  }

  get taskInternalStatusOptions() {
    return [
      { value: '', label: 'None', description: 'No internal status set.' },
      ...this.taskInternalStatuses.map(s => ({ value: s.guid, label: s.title, description: s.description, color: s.colour }))
    ];
  }

  async GetProject() {
    if (this.project == null) {
      console.log("Get PRoject");
      let project_data: any = await this.apiService.get(`projects/${this.task.project_guid}`);
      if (project_data.success) {
        this.project = project_data.data[0];
        if(this.project.all_team_members) {
          let team_members_data: any = await this.apiService.get(`team_members`);
          this.project.team_members = team_members_data.data;
        }
      }
    }
    console.log("PROJECT", this.project);
  }


  async GetTaskData() {
    let data: any = await this.apiService.get(`tasks/${this.guid}`);
    if (data.success) {
      this.task = data.data[0];
      if (!this.task.skills) this.task.skills = [];
      this.task_copy = JSON.stringify(this.task);

      // Check if task has role requirements
      if (this.task.role && this.task.role.guid) {
        this.require_roles = true;
        this.require_specific = this.task.require_specific || false;
      }
    }
    console.log("Task DATA");
    console.log(this.task);
  }

  async GetTotalCommentCount() {
    const data: any = await this.apiService.get(`projects/${this.task.project_guid}/all_comments?count=1`);
    if (data.success && data.data?.[0]) this.total_comment_count = data.data[0].count;
  }

  async GetTaskComments() {
    this.comments_loading = true;
    this.comment_filter = 'This Task';

    const result: any = await this.apiService.get(`projects/${this.task.project_guid}/all_comments`);
    const all: any[] = result.success ? (result.data || []) : [];

    this.this_task_comments = [];
    this.other_task_comments = [];
    this.project_comments_list = [];
    this.step_comments = [];

    for (const c of all) {
      if (c.source_type === 'project') {
        this.project_comments_list.push(c);
      } else if (c.source_type === 'task') {
        if (c.source_guid === this.task.guid) {
          this.this_task_comments.push({ ...c, source_type: 'this_task' });
        } else {
          this.other_task_comments.push({ ...c, source_type: 'other_task' });
        }
      } else if (c.source_type === 'step') {
        this.step_comments.push(c);
      }
    }

     // Format users field by parsing JSON strings
    const formatComments = (comments: any[]) => {
      for (const comment of comments) {
        if (comment.users && typeof comment.users === 'string') {
          comment.users = JSON.parse(comment.users);
        }
      }
    };

    formatComments(this.project_comments_list);
    formatComments(this.this_task_comments);
    formatComments(this.other_task_comments);
    formatComments(this.step_comments);

    this.task.comments = this.this_task_comments;
    this.all_comments = all;
    this.total_comment_count = all.length;
    this.comments_loading = false;
  }

  GetFilteredTaskComments() {
    if (this.comment_filter === 'Other Tasks') return this.other_task_comments;
    if (this.comment_filter === 'Project') return this.project_comments_list;
    if (this.comment_filter === 'Steps') return this.step_comments;
    return this.this_task_comments;
  }

  SetTaskCommentFilter(filter: string) {
    this.comment_filter = filter;
    this.CancelTaskReply();
  }

  StartTaskReply(comment: any) {
    this.active_reply_guid = comment.guid;
    this.reply_comment = { reply_to: comment.guid, reply_to_text: comment.comment, reply_to_name: comment.users?.[0]?.display_name, comment: '', update: false };
  }

  CancelTaskReply() {
    this.active_reply_guid = null;
    this.reply_comment = { reply_to: null, reply_to_text: null, reply_to_name: null, comment: '', update: false };
  }

  async SubmitTaskReply(comment: any) {
    let url = 'tasks/comments'; let guid = this.task.guid;
    if (comment.source_type === 'project') { url = 'projects/comments'; guid = this.project.guid; }
    else if (comment.source_type === 'other_task') { url = 'tasks/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'step') { url = 'steps/comments'; guid = comment.source_guid; }

    const data: any = await this.apiService.post(`${url}/${guid}`, this.reply_comment);
    if (data.success) {
      const nc: any = data.data[0];
      nc.users = [{ display_name: this.current_user.display_name, guid: this.current_user.guid }];
      nc.comment = JSON.parse(JSON.stringify(this.reply_comment.comment));
      nc.reply_to_guid = this.reply_comment.reply_to;
      nc.source_type = comment.source_type; nc.source_title = comment.source_title; nc.source_guid = comment.source_guid;
      if (comment.source_type === 'project') this.project_comments_list.unshift(nc);
      else if (comment.source_type === 'other_task') this.other_task_comments.unshift(nc);
      else if (comment.source_type === 'step') this.step_comments.unshift(nc);
      else { this.this_task_comments.unshift(nc); if (this.task.comments) this.task.comments.unshift(nc); }
      this.all_comments.unshift(nc);
      this.total_comment_count = this.all_comments.length;
      this.CancelTaskReply();
    }
    this.globalService.presentToastMessage(data.message, data.success);
  }

  async ViewOtherTask(comment: any) {
    const modal = await this.modalController.create({
      component: DetailsPage,
      componentProps: { guid: comment.source_guid, project: this.project },
      backdropDismiss: true,
      cssClass: 'large-modal secondary-modal'
    });
    modal.present();
  }

  async ViewStepFromTaskComment(comment: any) {
    const { DetailsPage: StepPage } = await import('src/app/steps/details/details.page');
    const modal = await this.modalController.create({
      component: StepPage,
      componentProps: { guid: comment.source_guid, project: this.project, task: this.task },
      backdropDismiss: true,
      cssClass: 'large-modal secondary-modal'
    });
    modal.present();
  }

  async GetOpenMissingInfoCount() {
    const data: any = await this.apiService.get(`missing_info?completed=0&project=${this.task.project_guid}&count=1`);
    if (data.success && data.data) this.open_missing_info_count = data.data[0].count;
    else this.open_missing_info_count = 0;

    console.log("Open Missing Info Count: ", this.open_missing_info_count);
  }

  async GoToStep(val) {
    this.activeIndex = val;
    if (val == 'Comments') {
      this.comment_filter = 'This Task';
      this.CancelTaskReply();
      this.GetTaskComments();
    }
    if (val == 'Missing Info') {
      this.GetOpenMissingInfoCount();
    }
    if (val == 'Time Entries') {
      this.LoadTimeEntries();
    }
  }

  async LoadTimeEntries() {
    this.time_and_billing = this.task?.guid ? await this.timeAndBillingService.GetEntries({ task_guid: this.task.guid }) : [];
  }

  get timeRecordedMinutes(): number {
    let total = 0;
    for (const entry of this.time_and_billing) {
      if (!entry.start_date || !entry.end_date) continue;
      const diff = this.globalService.GetTimeDifferenceAsObject(entry.start_date, entry.end_date);
      total += (diff.hours * 60) + diff.minutes;
    }
    return total;
  }

  get estimatedTimeRemainingMinutes(): number {
    return (Number(this.task?.estimated_time) || 0) - this.timeRecordedMinutes;
  }

  get timeRecordedPercent(): number {
    const est = Number(this.task?.estimated_time) || 0;
    if (est === 0) return this.timeRecordedMinutes > 0 ? 100 : 0;
    return Math.min(100, Math.round((this.timeRecordedMinutes / est) * 100));
  }

  async AddTimeEntry() {
    const modal = await this.modalController.create({
      component: TimeAndBillingCreatePage,
      cssClass: 'large-modal',
      componentProps: { project: this.project, task: this.task },
    });
    modal.onDidDismiss().then(() => this.LoadTimeEntries());
    return await modal.present();
  }

  //This is fired when a step was updated
  //When its changed we want to refresh the task list because other tasks might have been completed by this task being completed
  stepModified(eventData: { data: any }) {
    console.log("On Task Update");
    this.GetData();
    this.refresh = true;
  }

  Dismiss() {
    this.modalController.dismiss({ refresh: this.refresh });

  }

  @ViewChild('topRowRef', { static: false }) topRowRef: ElementRef | undefined;
  @ViewChild('footerRowRef', { static: false }) footerRowRef: ElementRef | undefined;
  @ViewChild('navRowRef', { static: false }) navRowRef: ElementRef | undefined;
  GetCommentsSize() {
    const el = this.topRowRef.nativeElement as HTMLElement;
    const rect = el.getBoundingClientRect();
    const footerEl = this.footerRowRef.nativeElement as HTMLElement;
    const footerRect = footerEl.getBoundingClientRect();
    const navEl = this.navRowRef.nativeElement as HTMLElement;
    const navRect = navEl.getBoundingClientRect();
    let allowed_size = Math.round(rect.height) - (Math.round(footerRect.height) + Math.round(navRect.height));
    console.log("Allowed Size:", allowed_size);
    return allowed_size - 1;
  }

  async GetClientRoles() {
    let data: any = await this.apiService.GetRoles();
    if (data.success) this.client_roles = data.data;
  }




  //This opens the create modal in task edit mode for the current task
  async StartTaskEdit() {
    await this.globalService.presentLoading("Preparing Task Edit", 99999999);
    await this.UpdateProjectTeamMembers();
    this.current_edit_task_copy = JSON.stringify(this.task);
    await this.globalService.dismissLoading();
    const modal = await this.modalController.create({
      component: CreatePage,
      cssClass: 'large-modal',
      backdropDismiss: false,
      componentProps: {
        project: this.project,
        task: this.task,
        edit_mode: true
      },
    })
    modal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.UpdateProjectTasks();
        this.refresh = true;
      }
    });
    return await modal.present()
  }

  async UpdateProjectTeamMembers() {
    if(this.project.all_team_members) return;
    for (let i = 0; i < this.project.team_members.length; i++) {
      let data: any = await this.apiService.get(`team_members/${this.project.team_members[i].guid}`);
      if (data.success) {
        this.project.team_members[i] = data.data[0];
      }
    }
    this.refresh = true;
  }


  async UpdateProjectTasks() {
    await this.globalService.presentLoading("Updating Project Tasks", 99999999);
    let old_task_data: any = JSON.parse(this.task_copy);

    const task = this.task;
    // Task exists in old data, check if it has changed
    // Log the differences
    const oldTask = old_task_data;
    const differences = {};

      Object.keys(task).forEach(key => {
        if (JSON.stringify(task[key]) !== JSON.stringify(oldTask[key])) {
          differences[key] = {
            old: oldTask[key],
            new: task[key]
          };
        }
      });

      await this.apiService.put(`tasks/${task.guid}`, task);

      // Handle step changes
      if (differences['steps']) {
        const oldSteps = old_task_data.steps || [];
        const newSteps = task.steps || [];

        // Check for modified and new steps
        for (let j = 0; j < newSteps.length; j++) {
          const step = newSteps[j];
          const oldStepIndex = oldSteps.findIndex(s => s.guid === step.guid);

          if (oldStepIndex !== -1) {
            // Step exists, check if modified
            if (JSON.stringify(step) !== JSON.stringify(oldSteps[oldStepIndex])) {
              console.log("Step Updated: ", step);
              step.project_guid = this.project.guid;
              step.task_guid = task.guid;
              step.task_start_date = task.start_date;
              step.task_end_date = task.due_date;
              await this.apiService.put(`steps/${step.guid}`, step);
            }
          } else {
            // New step
            step.task_guid = task.guid;
            step.order_num = j;
            step.project_guid = this.project.guid;
            step.task_guid = task.guid;
            step.task_start_date = task.start_date;
            step.task_end_date = task.due_date;
            console.log("New Step Found: ", step);
            await this.apiService.post(`steps`, step);
          }
        }

        // Check for deleted steps
        for (let j = 0; j < oldSteps.length; j++) {
          const step = oldSteps[j];
          const newStepIndex = newSteps.findIndex(s => s.guid === step.guid);

          if (newStepIndex === -1) {
            console.log("Deleting Step: ", step);
            await this.apiService.delete(`steps/${step.guid}`, null);
          }
        }
      }




    this.GetData();
    this.globalService.dismissLoading();

  }

  formatMinutesToDuration(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    
    if (hours === 0) {
      return `${mins} minute${mins !== 1 ? 's' : ''}`;
    }
    if (mins === 0) {
      return `${hours} hour${hours !== 1 ? 's' : ''}`;
    }
    return `${hours} hour${hours !== 1 ? 's' : ''} ${mins} minute${mins !== 1 ? 's' : ''}`;
  }

  IsAdminOrProjectLeader() {
    if (this.globalService.GetCurrentUser().is_admin) return true;
    if (this.project.team_leader && this.project.team_leader.guid == this.globalService.GetCurrentUser().guid) return true;
    return false;
  }

  IsClaimable() {
    if(!this.task) return false;
    if(!this.project) return false;

    if (this.task.assignment_settings !== 1) return false;
    if(this.task.assigned_member_guid != '') return false;
    if(this.project.all_team_members) return true;
    for (let member of this.project.team_members) {
      if (member.role === 2 && member.guid === this.globalService.GetCurrentUser().guid) {
        return true;
      }
    }
      
      return false;
  }

  async ClaimTask() {
    const alert = await this.alertController.create({
      header: 'Claim Task',
      message: 'Are you sure you want to claim this task?',
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Claim',
          handler: async () => {
            this.task.assigned_member_guid = this.globalService.GetCurrentUser().guid;
            this.task.team_member_assigned_name = this.globalService.GetCurrentUser().display_name;
            try {
              await this.apiService.put(`tasks/${this.task.guid}/assign`, { team_member_guid: this.task.assigned_member_guid, release: false });
            } catch (e) {
              this.task.assigned_member_guid = '';
              this.task.team_member_assigned_name = '';
              this.globalService.presentToastMessage('Failed to release task', false);
            }
            this.refresh = true;
          }
        }
      ]
    });
    await alert.present();
  }


  async ReleaseTask() {
    const alert = await this.alertController.create({
      header: 'Release Task',
      message: 'Are you sure you want to release this task? It will become available for others to claim.',
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Release',
          handler: async () => {
            const previousGuid = this.task.assigned_member_guid;
            this.task.assigned_member_guid = '';
            this.task.team_member_assigned_name = '';
            try {
              await this.apiService.put(`tasks/${this.task.guid}/assign`, { team_member_guid: previousGuid, release: true });
            } catch (e) {
              this.task.assigned_member_guid = previousGuid;
              this.task.team_member_assigned_name = this.globalService.GetCurrentUser().display_name;
              this.globalService.presentToastMessage('Failed to release task', false);
            }
            this.refresh = true;
          }
        }
      ]
    });
    await alert.present();
  }

  async AssignMember(guid: string) {
    await this.globalService.presentLoading('Assigning Task', 99999999);
    this.task.assigned_member_guid = guid ?? '';
    await this.apiService.put(`tasks/${this.task.guid}/assign`, { team_member_guid: this.task.assigned_member_guid });
    this.inline_assign_member_guid = null;
    this.refresh = true;
    this.globalService.dismissLoading();
  }

   GetTeamMemberDisplayNameByGuid(guid) {
    if(!this.project) return '';
    if(!this.project.team_members) return '';
    if(guid == '') return "Unassigned";
    const member = this.project.team_members.find(tm => tm.guid === guid);
    return member ? member.display_name : '';
  }

  async ViewProject() {
      const modal = await this.modalController.create({
        component: ProjectDetailsPage,
        componentProps: {
          guid: this.project.guid
        },
        backdropDismiss: true,
        cssClass: 'large-modal secondary-modal'
      });
      modal.onDidDismiss().then((data: any) => {
        if(data.data && data.data.refresh) this.GetData();
    });
      modal.present();
    }

    async MarkTaskAsComplete() {
      const alert = await this.alertController.create({
      header: 'Force Complete Task',
      message: 'Are you sure you want to force complete this task? It will automatically mark all actions as complete. This action cannot be undone.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Confirm',
          handler: async () => {
            for (let step of this.task.steps) {
              this.globalService.presentLoading(`Marking Task as Complete. Action: ${step.title}`, 99999999);
              await this.apiService.put(`steps/${step.guid}/complete/true?skip_start=1`, null);
            }
            this.refresh = true;
            await this.globalService.dismissLoading();
            this.GetData();

          }
        }
      ]
    });
    await alert.present();

    }

    IsPreviousTaskCompleted() {
    if (!this.project || !this.project.tasks || this.project.tasks.length === 0) {
      return true;
    }
    if(!this.project.force_order) {
      return true;
    } 

    const currentTaskIndex = this.project.tasks.findIndex(t => t.guid === this.task.guid);
    if (currentTaskIndex <= 0) {
      return true;
    }

    const previousTask = this.project.tasks[currentTaskIndex - 1];
    if(previousTask.status == TaskStatus.awaiting_previous_task) return false;

    if(previousTask.status != TaskStatus.completed) {
      previousTask.status = TaskStatus.awaiting_previous_task;
      return false;
    }
    else return true;
  }

   SolveProjectStatus(project) {
    if(project.status == -1) {
      if(project.progress == 0) return "Inactive"
      else return "Active";
      }
      else if (project.status == 0 || project.status == 2) {
          return 'Active'
      } else if (project.status == 1) {
          return 'Completed'
      } 

    return "";

  }
  



}
